import { render, staticRenderFns } from "./BackgroundSettings.vue?vue&type=template&id=e836b210&scoped=true"
import script from "./BackgroundSettings.vue?vue&type=script&lang=js"
export * from "./BackgroundSettings.vue?vue&type=script&lang=js"
import style0 from "./BackgroundSettings.vue?vue&type=style&index=0&id=e836b210&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e836b210",
  null
  
)

export default component.exports